import {SpinButtonView} from '@gongxigames/framework/slot/modules/spinbutton/SpinButtonView';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {Button, DeviceType} from '@gongxigames/framework/core';

export abstract class SpinButtonBaseViewMobile extends SpinButtonView {
    public static readonly NAME: symbol = Symbol('SpinButtonBaseViewMobile');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.MOBILE;

    public static readonly SPINS_LEFT_BUTTON_CLICKED = Symbol('SPINS_LEFT_BUTTON_CLICKED');

    protected _spinsLeftButton!: Button;

    protected _holdEnabled = true;

    public abstract enableSpinsLeftButton(): void;

    public abstract disableSpinsLeftButton(): void;

    public set spinsLeftButton(value: Button) {
        this._spinsLeftButton = value;
    }

    public enableHold(): void {
        this._holdEnabled = true;
    }

    public disableHold(): void {
        this._holdEnabled = false;
    }

    public setSprite(name: string): void {}
}
